/**
 * Nicky's Additions - 2025
 */



document.addEventListener("DOMContentLoaded", () => {
  if (gsap) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.config({
      force3D: false,
    })
  }

  bgImageBlock();
  breadcrumbStripColor();
  dialogOpenClose();
  esgPages();
  klaviyoFormTriggers();
  mainNavigation();
  mpgCircleRotator();
  const pauseAnimControl = new PauseAnimControlDef();
  pauseAnimControl.init();
  plpVideoHoverPlay();
  removeShopPayAd();
  // scrollSmoother();
  slideshowHeight();
  // swiper();
  removeShopPayAd();
  roundCentlessPrices();
  timedContent();
  unitToggle();
});




function bgImageBlock() {
  // Assigns 'position:relative' to the parent element 
  // Only when set to block relativity vs section (--relativity-block)
  // Remove hidden attribute that was placed to remove flash of misplaced content
  let blocks = document.querySelectorAll('.mci-block-bg-image--relativity-block');
  if (blocks) {
    blocks.forEach((block) => {
      let blockParent = block.parentElement;
      if (blockParent) {
        blockParent.classList.add('relative');
        block.classList.remove('hidden');
      }
    });
  };
}

function breadcrumbStripColor() {
  // Remove the "- Colour Name" from the breadcrumbs
  let productTemplate = document.body.classList.contains('template-product');
  let breadcrumbs = document.querySelector('.breadcrumb__list--pdp');

  if (productTemplate && breadcrumbs) {
    let breadcrumbCount = breadcrumbs.children.length - 1;
    let lastBreadcrumb = breadcrumbs.children[breadcrumbCount].firstElementChild;
    let lastBreadCrumbArray = lastBreadcrumb.innerText.split(' - ');
    if (lastBreadCrumbArray.length > 2) {
      lastBreadcrumb.innerText = lastBreadCrumbArray[0] + lastBreadCrumbArray[1];
    } else {
      lastBreadcrumb.innerText = lastBreadCrumbArray[0];
    }
  }

}

function dialogOpenClose() {
  const dialog = document.querySelector("dialog");
  const showButton = document.querySelector("dialog + button");
  const closeButton = document.querySelector("dialog button");

  // "Show the dialog" button opens the dialog modally
  showButton.addEventListener("click", () => {
    dialog.showModal();
  });

  // "Close" button closes the dialog
  closeButton.addEventListener("click", () => {
    dialog.close();
  });
}

function esgPages() {
  if (window.matchMedia('screen and (min-width: 1000px)').matches) {

    let sectionBlockAnimate = document.querySelectorAll('.section-block-animate');
    let sectionBlockAnimateTrigger = document.querySelectorAll('#animate-trigger');
    if (sectionBlockAnimate) {
      gsap.from(sectionBlockAnimate, {
        autoAlpha: 0,
        duration: 1,
        x: '3500',
        stagger: 0.1,
        ease: 'none',
        scrollTrigger: {
          trigger: sectionBlockAnimateTrigger,
          start: 'top bottom+=25%',
          end: 'bottom center+=25%',
          scrub: 3
        }
      })
    }

    let bulletsFirst = document.querySelectorAll('ul.first-bullets li');
    let bulletsFirstTrigger = document.querySelectorAll('.first-bullets-animation');
    if (bulletsFirst && bulletsFirstTrigger) {
      gsap.from(bulletsFirst, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsFirstTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsSecond = document.querySelectorAll('ul.second-bullets li');
    let bulletsSecondTrigger = document.querySelectorAll('.second-bullets-animation');
    if (bulletsSecond && bulletsSecondTrigger) {
      gsap.from(bulletsSecond, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsSecondTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsThird = document.querySelectorAll('ul.third-bullets li');
    let bulletsThirdTrigger = document.querySelectorAll('.third-bullets-animation');
    if (bulletsThird && bulletsThirdTrigger) {
      gsap.from(bulletsThird, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsThirdTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsFourth = document.querySelectorAll('ul.fourth-bullets li');
    let bulletsFourthTrigger = document.querySelectorAll('.fourth-bullets-animation');
    if (bulletsFourth && bulletsFourthTrigger) {
      gsap.from(bulletsFourth, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsFourthTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
  }


  let contentAnimated = document.querySelectorAll('.content-animated');
  let contentAnimatedTrigger = document.querySelectorAll('#animate-content');
  if (contentAnimated && contentAnimatedTrigger) {
    gsap.from(contentAnimated, {
      opacity: 0,
      y: -100,
      ease: 'none',
      duration: 3,
      autoAlpha: 0,
      scrollTrigger: {
        trigger: contentAnimatedTrigger,
        start: 'top center+=50%',
        scrub: true
      }
    })
  }

  let tencelIcons = document.querySelectorAll('#tencel-icons .image-wrapper');
  let tencelIconsTrigger = document.querySelectorAll('#tencel-icons');
  if (tencelIcons && tencelIconsTrigger) {
    if (window.matchMedia('screen and (min-width: 1000px)').matches) {
      gsap.from(tencelIcons, {
        opacity: 0,
        x: -500,
        ease: 'back.inOut',
        stagger: 0.1,
        duration: 1,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: tencelIconsTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      }, 0.2)

      if (window.matchMedia('screen and (max-width: 999px)').matches) {
        gsap.from(tencelIcons, {
          opacity: 0,
          x: -100,
          ease: 'back.inOut',
          stagger: 0.2,
          autoAlpha: 0,
          duration: 5,
          scrollTrigger: {
            trigger: tencelIconsTrigger,
            start: 'top center+=30%',
            end: 'bottom center+=30%',
            scrub: true
          }
        })
      }
    }
  }

  let esgChain = document.querySelectorAll('#esg-chain .image-wrapper');
  let esgChainTrigger = document.querySelectorAll('#esg-chain');
  if (esgChain && esgChainTrigger) {
    if (window.matchMedia('screen and (max-width: 1099px)').matches) {
      gsap.from(esgChain, {
        opacity: 0,
        x: -100,
        ease: 'back.inOut',
        stagger: 0.2,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: esgChainTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      })
    }

    if (window.matchMedia('screen and (min-width: 1100px)').matches) {
      gsap.from(esgChain, {
        opacity: 0,
        x: -500,
        ease: 'back.inOut',
        stagger: 0.1,
        duration: 1,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: esgChainTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      }, 0.2)
    }
  }

  if (window.matchMedia('screen and (min-width: 699px)').matches) {
    let tencelProcess = document.querySelectorAll('#tencel-process .image-wrapper');
    let tencelProcessTrigger = document.querySelectorAll('#tencel-process');
    if (tencelProcess && tencelProcessTrigger) {
      gsap.from(tencelProcess, {
        opacity: 0,
        y: -500,
        ease: 'back.inOut',
        stagger: 0.2,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: tencelProcessTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      })
    }
  }
}

function klaviyoFormTriggers() {
  let maClub = document.querySelector('#klaviyo_form_trigger_ma_club');
  if (maClub) {
    maClub.addEventListener('click', function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WeAGvZ']);
    });
  }
  let mondettaEmail = document.querySelector('#klaviyo_form_trigger_mondetta');
  if (mondettaEmail) {
    mondettaEmail.addEventListener('click', function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'VWmk4x']);
    });
  }
}

function mainNavigation() {
  let dropdownButtons = document.querySelectorAll('.dropdown-toggle');
  let mobileMenuButton = document.getElementById('navToggle');

  /**
   * Main mobile navigation toggle
   * - Functioning, styling needed
   */
  if (mobileMenuButton) {
    mobileMenuButton.addEventListener("click", () => {
      event.preventDefault();
      let isExpanded = mobileMenuButton.getAttribute("aria-expanded");

      if (isExpanded == "false") {
        mobileMenuButton.setAttribute("aria-expanded", "true");
      } else {
        mobileMenuButton.setAttribute("aria-expanded", "false");
      }

      document.body.classList.toggle("nav-open");
    });
  }


  if (dropdownButtons) {
    /**
     * FUNCTION
     * Close all open dropdowns
     */
    function closeAllDropDowns() {
      dropdownButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
    }

    /**
     * FUNCTION
     * Toggle dropdown open/close
     */
    function toggleDropdown(event, button) {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      closeAllDropDowns();

      if (!isExpanded) {
        button.setAttribute("aria-expanded", "true");
      }
    }

    /**
     * FUNCTION
     * Close dropdown when clicking outside
     * - Does not work at the moment
     */
    function closeOnBlur(button, options = {}) {
      document.addEventListener("click", (event) => {
        if (
          event.target.parentElement.classList.contains("js-mci-nav-link") ||
          event.target.parentElement.classList.contains("nav-main__primary") ||
          event.target.parentElement.classList.contains("nav-main__primary__submenu")
        ) {
          // do nothing
        } else {
          closeAllDropDowns();
          document.body.classList.remove("nav-open");
        }
      });
    }

    /**
     * FUNCTION
     * Closes dropdowns when tabbing out of them
     */
    function handleFocus(button) {
      const subMenuListElement = button.nextElementSibling;

      if (subMenuListElement) {
        button.addEventListener("focusout", (event) => {
          event.stopImmediatePropagation();
        });

        subMenuListElement.addEventListener("focusout", (event) => {
          const nextFocusElement = event.relatedTarget;

          const isSubMenuElement =
            nextFocusElement &&
            nextFocusElement.classList.contains("button") ||
            nextFocusElement.classList.contains("link") ||
            nextFocusElement.classList.contains("js-mci-nav-link");

          if (!isSubMenuElement) {
            closeAllDropDowns();
          }
        });
      }
    }

    /**
     * EVENT
     * Adds event listeners to dropdown buttons (desktop)
     */

    dropdownButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        toggleDropdown(event, button);
      });

      closeOnBlur(button);
      handleFocus(button);
    });

    /**
     * EVENT
     * Closes menu on escape key
     */
    window.addEventListener("keydown", (event) => {
      if (event.key == "Escape") {
        document.body.classList.remove("nav-open");
        // mobileMenuButton.setAttribute("aria-expanded", "false");
        closeAllDropDowns();
      }
    });
  }
}

function mpgCircleRotator() {
  // Scripts required to make the MPG Circle Rotating Text block work

  const rotator = document.querySelector('.rotator');
  const playPause = document.querySelector('.mci-section-mpg-circle-rotating-text .mci-playpause-button');

  if (rotator) {
    let animation = gsap.timeline({ repeat: 20 });
    let targets = document.querySelectorAll('.rotator span');
    let numberOfTargets = targets.length;

    let duration = 0.6;
    let pause = 2;

    let stagger = duration + pause;
    let repeatDelay = stagger * (numberOfTargets - 1) + pause;

    function init() {
      gsap.set('.rotator', { autoAlpha: 1 });
      animation
        .from(targets, {
          y: 80,
          duration: duration,
          opacity: 0,
          ease: 'power2.out',
          stagger: {
            each: stagger,
            repeat: -1,
            repeatDelay: repeatDelay,
          },
        })
        .to(
          targets,
          {
            y: -80,
            duration: duration,
            opacity: 0,
            ease: 'power2.out',
            stagger: {
              each: stagger,
              repeat: -1,
              repeatDelay: repeatDelay,
            },
          },
          stagger
        );
    }
    // play/pause
    playPause.addEventListener('click', () => {
      animation.paused(!animation.paused());
      if (playPause.getAttribute('aria-label') == 'Pause') {
        playPause.setAttribute('aria-label', 'Play');
      } else {
        playPause.setAttribute('aria-label', 'Pause');
      }
    });

    init();
  }
}

function plpVideoHoverPlay() {
  let plpVideos = document.querySelectorAll('.product-card__media video');

  if (plpVideos.length != 0) {
    plpVideos.forEach((video) => {
      let videoCover = video.parentElement.querySelector('img');
      video.style.opacity = 1;

      video.parentElement.addEventListener('mouseover', (event) => {
        video.play();
        videoCover.style.opacity = 0;
      });

      video.parentElement.addEventListener('mouseout', (event) => {
        video.pause();
        videoCover.style.opacity = 1;
      });
    });
  }
}

function removeShopPayAd() {
  let multiPackProduct = document.querySelector('.product--same-color, .product--different-color');
  let shopPayAd = document.querySelector('div[data-block-type="payment-terms"]');
  if (multiPackProduct) {
    shopPayAd.hidden = true;
  }
}

function roundCentlessPrices() {
  if (document.body.classList.contains('js-mci-round-centless-prices')) {
    let priceArray = document.querySelectorAll('sale-price');
    let compareAtArray = document.querySelectorAll('compare-at-price');

    priceArray.forEach(price => {
      if (price.innerHTML.includes(".00")) {
        price.innerHTML = price.innerHTML.replace(".00", "");
      }
    });

    compareAtArray.forEach(price => {
      if (price.innerHTML.includes(".00")) {
        price.innerHTML = price.innerHTML.replace(".00", "");
      }
    });
  }
}

function scrollSmoother() {
  gsap.registerPlugin(ScrollSmoother);

  if (ScrollSmoother) {
    // init
    ScrollSmoother.create({
      smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
      effects: true, // looks for data-speed and data-lag attributes on elements
      smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    });

    // fix sticky stuff on PDP
    ScrollTrigger.create({
      trigger: "safe-sticky",
      start: "top",
      endTrigger: "scroll-carousel",
      end: "bottom bottom",
      pin: true,
      scrub: 1,
    });

  }

}

function slideshowHeight() {
  let firstSlideshowImages = document.querySelectorAll('.slideshow__slide:first-of-type img');
  let slideshows = document.querySelectorAll('.mci-section-slideshow');

  if (slideshows) {
    function removePlaceholderHeight() {
      slideshows.forEach(slideshow => {
        slideshow.classList.remove('slideshow--placeholder-height');
      });
    }
    firstSlideshowImages.forEach(image => {
      if (image.complete) {
        setTimeout(removePlaceholderHeight, 500);
      }
    });
  }
}

function swiper() {
  let checkForSwiper = document.querySelector('.swiper');
  if (checkForSwiper) {
    new Swiper('.swiper', {
      // Optional parameters
      a11y: true,
      direction: 'vertical',
      loop: false,
      parallax: true,
      speed: 800,
      oneWayMovement: true,

      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },

      scrollbar: {
        snapOnRelease: true,
      },

      accessibility: {
        enabled: true,
      },

      keyboard: {
        enabled: true,
      },

      virtual: {
        enabled: true,
        addSlidesAfter: 1,
      },

      mousewheel: {
        enabled: true,
        sensitivity: 0.005,
        // releaseOnEdges: true,
        thresholdDelta: 15,
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
        snapOnRelease: true,
      },
    });
  }

}

function timedContent() {
  // Show hide content with the class "js-timed" based on the set show and hide time
  // Uses HTML 'hidden' attribute

  let timedContent = document.querySelectorAll('.js-timed');

  if (timedContent) {
    let now = Date.now();

    timedContent.forEach((item) => {
      let showTime = parseInt(item.dataset.timedStart);
      let hideTime = parseInt(item.dataset.timedEnd);

      if (now >= showTime && now <= hideTime) {
        item.hidden = false;
      }

    });
  }
}

function unitToggle() {
  let inButton = document.querySelector("#mciUnitToggleIN");
  let cmButton = document.querySelector("#mciUnitToggleCM");
  let measurementTables = document.querySelectorAll(".mci-measurement-table");

  if (measurementTables && inButton && cmButton) {
    inButton.addEventListener('click', function () {
      inButton.setAttribute("aria-pressed", "true");
      cmButton.setAttribute("aria-pressed", "false");
      measurementTables.forEach((table) => {
        table.classList.add('mci-measurement-table--in');
        table.classList.remove('mci-measurement-table--cm');
      })
    });

    cmButton.addEventListener('click', function () {
      cmButton.setAttribute("aria-pressed", "true");
      inButton.setAttribute("aria-pressed", "false");
      measurementTables.forEach((table) => {
        table.classList.add('mci-measurement-table--cm');
        table.classList.remove('mci-measurement-table--in');
      })
    });
  }

}

function PauseAnimControlDef() {
  /*******************************************************************************
   * pause-anim-control.js - A global pause button for client side motion graphics
   * and videos.
   * 
   * Written by Zoltan Hawryluk <zoltan.dulac@gmail.com>
   * Part of the Enable accessible component library.
   * Version 1.0 released Dec 27, 2021
   *
   * More information about this script available at:
   * https://www.useragentman.com/enable/pause-anim-control.php
   * 
   * Released under the MIT License.
   ******************************************************************************/

  let timePausePressed = null;
  const pauseEvent = new CustomEvent('enable-pause-animations', { bubbles: true });
  const playEvent = new CustomEvent('enable-play-animations', { bubbles: true });

  // we store this globally so other components can use 
  // this without having to load this module.
  this.realRAF = window.requestAnimationFrame.bind(window);
  this.requestAnimationFrame = this.realRAF;

  /**
   * This will replace the real requestAnimationFrame method when the "Pause Animations"
   * checkbox is checked.  It basically does two things:
   * 
   * 1) For requestAnimationFrame calls done right after the checkbox is checked, 
   * this method will "hold on to them" until the checked box is unchecked.
   * 2) requestAnimationFrame calls after 500 ms will be dropped.
   * 
   * @param {func} func - A JavaScript function to be executed when a frame is available   
   * @param {Object} options - A JavaScript object with the following properties:
   *   - ignoreTime: this is used internally by dummyRAF to ensure that
   *     requestAnimationFrame calls that call itself will continute to do so until the 
   *     "Pause Animations" checkbox is unchecked.
   *   - useRealRAF: this can be used by developers to tell this method that 
   *     what they are doing is not an actual animation, but they want to do something
   *     at the next repaint.
   *   - isDelayed:  
   */
  this.dummyRAF = (func, options) => {
    const millisecs = Date.now() - timePausePressed;
    const { ignoreTime, useRealRAF } = options || {};
    const isAnimation = (func.toString().indexOf('requestAnimationFrame') > -1);

    if (!isAnimation || useRealRAF) {
      window.requestAnimationFrame(func);
    } else if (ignoreTime || millisecs <= 500) {
      setTimeout(() => {
        this.requestAnimationFrame(func, {
          ignoreTime: true
        });
      }, 500);
    }
    return;
  }

  this.pause = () => {
    const { body } = document;

    if (body.classList.contains(this.pauseClass)) {
      return;
    } else {
      // For CSS animations
      body.classList.add(this.pauseClass);
      body.classList.remove(this.playClass);

      // For JS animations
      this.requestAnimationFrame = this.dummyRAF;

      // for SVG animations
      document.querySelectorAll('svg').forEach((el) => {
        el.pauseAnimations();
      });

      // for AblePlayer videos
      if (typeof (AblePlayerInstances) !== 'undefined') {
        AblePlayerInstances.forEach(el => {
          if (el.playing) {
            el.pausedWithEnableControl = true;
            el.pauseMedia();
          }
        });
      }

      // for vanilla HTML5 Videos
      document.querySelectorAll('video').forEach((el) => {
        const { dataset } = el;
        if (!dataset.ablePlayer && !dataset.notPausableByEnable && !el.paused) {
          dataset.pausedWithEnableControl = true;
          el.pause();
        }
      });

      // fire pause event
      document.dispatchEvent(pauseEvent);

      localStorage.setItem(this.reduceMotionKey, true);

      timePausePressed = Date.now();
    }
  }

  this.play = () => {
    const { body } = document;

    // For CSS animations
    body.classList.remove(this.pauseClass);
    body.classList.add(this.playClass);

    // For JS animations
    this.requestAnimationFrame = this.realRAF;

    // for SVG animations
    document.querySelectorAll('svg').forEach((el) => {
      el.unpauseAnimations();
    });

    // for AblePlayer videos
    if (typeof (AblePlayerInstances) !== 'undefined') {
      AblePlayerInstances.forEach(el => {
        if (el.pausedWithEnableControl) {
          el.pausedWithEnableControl = false;
          el.playMedia();
        }
      });
    }

    // for vanilla HTML5 Videos
    document.querySelectorAll('video').forEach((el) => {
      const { dataset } = el;

      if (dataset.pausedWithEnableControl) {
        dataset.pausedWithEnableControl = false;
        el.play();
      }
    });

    // fire pause event.
    document.dispatchEvent(playEvent);

    localStorage.removeItem(this.reduceMotionKey);
  }

  this.pauseSMIL = (el) => {
    const svgEl = el.closest('svg');

    if (this.$checkbox.checked) {
      svgEl.pauseAnimations();
    }
  }

  this.clickEvent = () => {
    if (this.$checkbox.classList.contains(this.checkboxClass)) {
      if (this.$checkbox.checked) {
        this.pause();
      } else {
        this.play();
      }
    }
  }


  this.init = function () {
    this.rootClass = 'pause-anim-control';
    this.pauseClass = `${this.rootClass}__prefers-reduced-motion`;
    this.playClass = `${this.rootClass}__prefers-motion`;
    this.checkboxClass = `${this.rootClass}__checkbox`;
    this.$checkbox = document.querySelector(`.${this.checkboxClass}`);
    this.prefersReducedMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.reduceMotionKey = `${this.rootClass}__prefers-reduced-motion`;
    this.wasSetByUser = localStorage.getItem(this.reduceMotionKey) || false;

    if (!this.$checkbox) {
      console.warn('Pause checkbox is not in DOM. Bailing');
      return;
    }

    if (this.prefersReducedMotionMq.matches || this.wasSetByUser) {
      this.$checkbox.checked = true;
      this.pause();
    } else {
      this.$checkbox.checked = false;
      this.play();
    }

    this.prefersReducedMotionMq.addEventListener('change', (e) => {
      if (e.matches) {
        this.$checkbox.checked = true;
        this.pause();
      } else {
        this.$checkbox.checked = false;
        this.play();
      }
    });


    // Click event for the checkbox
    document.addEventListener('change', this.clickEvent);

    document.addEventListener('load', this.clickEvent);
    window.addEventListener('focus', this.clickEvent);
    document.querySelectorAll('animateMotion, animate').forEach((el) => {
      this.pauseSMIL(el);
    });

    // Safari will restart SVG animations when the browser tab becomes visible
    // after being pushed in the background, so we do this to work around it.
    document.addEventListener('visibilitychange', this.clickEvent);

  }

}